import { render } from "./NotMoveItemsLastNDays.vue?vue&type=template&id=f242efe4&scoped=true"
import script from "./NotMoveItemsLastNDays.vue?vue&type=script&lang=js"
export * from "./NotMoveItemsLastNDays.vue?vue&type=script&lang=js"

import "./NotMoveItemsLastNDays.vue?vue&type=style&index=0&id=f242efe4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f242efe4"]])

export default __exports__